// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyList-module__root--l2-oA Container-module__container--1e9BV","image":"EmptyList-module__image--1nYwo","text":"EmptyList-module__text--ob3Iy"};